import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import '@fontsource/roboto';
import overview from '../media/instruction/overview-nofinal.png';


const useStyles = theme => ({
    img:{
      maxWidth: '80%'
    },
    li:{
      paddingBottom: '10px'
    }
  });


class Main extends React.Component {

    constructor(props){
        super(props);
        this.handleStart=this.handleStart.bind(this);
    }

    handleStart(event){
        event.preventDefault();
        window.location='/informed-consent/';
        
    }

    render(){
      const { classes } = this.props;

        return (
            <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px'}}>
               <Typography variant='h5' className={classes.li}>
                 Activity Overview
                </Typography>
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <Typography variant='body1' component={'ul'}>
                  <li className={classes.li}>
                  In this activity, you are going to read a post and comments from an online discussion forum. As in most comment sections you commonly see online, you can write a comment to the post or reply to others' comments, or vote or react to others' comments.
                  </li>
                  <li className={classes.li}>
                  Along with the main activity, you are going to answer two surveys (pre-survey, post-survey) in total. This activity will take 30-40 minutes including the surveys.
                  </li >
                  <li className={classes.li}>
                  Please read the informed consent and instruction thoroughly. Response or submission that does not follow the instruction correctly can be rejected.
                  </li >
                </Typography>

                <Typography variant='body1' component={'ul'}>
                  <li> Below we illustrate the procedure. </li>
                      <img className={classes.img} id='img-vote' alt='overview of the process' src={overview} />
                </Typography>
              </div> 
              <div>
                <Typography variant={'body1'}>
                  To start, click 'NEXT' button.
                </Typography>
              </div>
                <div style={{float:'right', marginRight: '30px'}}>
                <form onSubmit={this.handleStart} >
                <Button variant='contained' color='primary'  className={classes.root} type="submit">
                 NEXT
                </Button>
              </form>
              </div>
            </div>
          );
    }
}

export default withStyles(useStyles)(Main);
